import { array, object, string, TypeOf } from 'zod';

/* ------------------------------- PersonType ------------------------------- */

export const PersonType = object({
    id: string(),

    name: string(),
});

export type PersonType = TypeOf<typeof PersonType>;

/* ----------------------------- AllPersonTypes ----------------------------- */

export const AllPersonTypes = object({
    data: array(PersonType),
});

export type AllPersonTypes = TypeOf<typeof AllPersonTypes>;
